import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

import Topbar from '../containers/components/Topbar';

import light from '../themes';
import './styles/masterlayout.css';


const theme = createMuiTheme(light);


class Master extends Component {

  constructor(props, context) {
    super(props);
    this.state = {}
  }


  render() {
    return (
      <MuiThemeProvider theme={theme}>
      <div className="layout-master-container">

        <Topbar title={this.props.navbarTitle}/>


        <div className="layout-master-content-container">
          {this.props.io.loading && (
            <div style={{position: 'absolute', top: 63, left: 0, right: 0}}>
              <LinearProgress color="primary" />
            </div>
          )}

          {this.props.children}
        </div>


      </div>
      </MuiThemeProvider>
    );
  }
}

Master.contextTypes = {
   router: PropTypes.object,
}

export default Master;



// WEBPACK FOOTER //
// ./src/layouts/MasterLayout.js